export enum DashboardEvents {
  // Header top menu
  CLICKED_MENU_HAMBURGER = `click_hamburger_menu`,
  CLICKED_MENU_HAMBURGER_PRODUCTS = `BurgerMenuClick`,
  CLICKED_MENU_SEARCH = `click_search_icon`,
  CLICKED_HOM_LOGO = `click_hom_logo`,

  // Mobile menu
  CLICKED_BOTTOM_MOBILE_MENU_HOME = `click_bottom_mobile_home_menu`,
  CLICKED_BOTTOM_MOBILE_MENU_LEAGUE = `click_bottom_mobile_league_menu`,
  CLICKED_BOTTOM_MOBILE_MENU_STATISTICS = `click_bottom_mobile_statistics_menu`,
  CLICKED_BOTTOM_MOBILE_MENU_CHAT = `click_bottom_mobile_chat_menu`,
  CLICKED_BOTTOM_MOBILE_ALL_MATH = `click_bottom_mobile_all_math`,

  // Dashboard statistics
  CLICKED_DASHBOARD_LEAGUE_VIEW = `click_dashboard_league_view`,
  CLICKED_DASHBOARD_STATS_VIEW = `click_dashboard_stats_view`,
  CLICKED_DASHBOARD_GAMES_VIEW = `click_dashboard_games_view`,
  CLICKED_DASHBOARD_ALL_MATH_VIEW = `click_dashboard_stats_view`,
  CLICKED_DASHBOARD_HOME_VIEW = `click_dashboard_home_view`,

  // Dashboard learning
  CLICKED_DASHBOARD_LATEST_LEARNING = `click_latest_learning`,
}
